export default __webpack_public_path__ + "static/media/18.6d24a17b.mp3";